/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Factory"], function (require, exports, Factory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ActionsHubManager = /** @class */ (function (_super) {
        __extends(ActionsHubManager, _super);
        function ActionsHubManager() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        /**
         * Get an instance of actions hub. Use actions hub when there is no logic that needs to be performed as part of actions.
         */
        ActionsHubManager.GetActionsHub = function (actionsHubClass, instanceId) {
            return _super.getInstance.call(this, ActionsHubManager).getObject(actionsHubClass, instanceId);
        };
        /**
         * Get all instances of the actions hub for the class. This is used by unit tests to raise actions that changes stores deep in the
         * hierarchy.
         */
        ActionsHubManager.GetAllActionsHub = function (actionsHubClass) {
            return _super.getInstance.call(this, ActionsHubManager).getAllObjects(actionsHubClass);
        };
        ActionsHubManager.dispose = function () {
            return _super.getInstance.call(this, ActionsHubManager).dispose();
        };
        return ActionsHubManager;
    }(Factory_1.Manager));
    exports.ActionsHubManager = ActionsHubManager;
});
